<template>
    <div class="item-container">

        <div class="item-title" v-if="item.title">{{item.title}}<span v-if="item.unit">({{item.unit}})</span>:</div>
        <div class="item-value">

            <div v-for="(value, index) in item.value" :key="index" style="color:#0D94FF">
               <p :class="{color1:value.isDangerous==true}"> <span  v-if="value.name"> {{value.name+':'}} </span>{{value.value}}</p>

            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            item: Object,
        },
        mounted() {
            // console.log( this.item)

        },
        // computed: {
        //     colorStyle() {
        //         if(this.item.value.length>1){
        //             var all = this.item.value.filter(element => {
        //             if (element.isDangerous) {
        //                 console.log(element)
        //                 return element
        //            }
        //         });
        //         console.log(all[0].isDangerous)
        //         return {
        //             color: all[0].isDangerous ? '#FD4238' : '#0D94FF'
        //         }
        //         }else{
        //             return {
        //             color:this.item.isDangerous ? '#FD4238' : '#0D94FF'
        //         }
        //         }
        //     },
            // colorStyle1() {
            //     var all = this.item.value.filter(element => {
            //         if (element.isDangerous) {
            //             console.log(element)
            //             return element
            //         }
            //     });
            //     console.log(all)
            //     return {
            //         color: all.isDangerous ? '#FD4238' : '#0D94FF'
            //     }
            // }
        // },
    }
</script>
<style lang="less" scoped>
    .item-container {
        display: flex;
        // .w(375);
        width: 100%;
        margin-top: 10px;
    }

    .item-title {
        width: 25%;

        font-size: 16rem;
        font-weight: 400;
        color: #666666;
    }

    .item-value {
        display: flex;
        width: 75%;

        font-size: 16rem;
        font-weight: 400;
    }

    .item-value>div {
        width: 30%;
    }
    .color1{
        color:red
    }
</style>